import styled from 'styled-components';
import { Text } from 'rebass/styled-components';

import { CheckoutAccordionSummary } from 'shared/components';

export const StyledCheckoutAccordionSummary = styled(CheckoutAccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 0 15px;
  }
`;

export const SuccessText = styled(Text)`
  font-size: 12px;
  font-weight: bold;
  padding-left: 15.6px;

  color: ${({ theme }) => theme.colors?.green[40]};
`;

export const HeaderText = styled(Text)`
  padding-top: 14px;
  padding-bottom: 5px;
  margin: 0 auto;
  line-height: 175%;
  font-size: 14px;
  font-weight: bold;

  color: var(--dcm-checkout-text-color);
`;
